import styled from 'styled-components';

export const H3 = styled.h3`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-weight: 300;
  font-size: 45px;
  line-height: 55px;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};

  @media (max-width: 992px) {
    font-size: 30px;
    line-height: 44px;
  }
`;

export const H4 = styled.h4`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 42px;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'initial')};

  @media (max-width: 992px) {
    font-size: 24px;
    line-height: 34px;
  }
`;

export const H2 = styled.h2`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 42px;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'initial')};

  @media (max-width: 992px) {
    font-size: 24px;
    line-height: 34px;
  }
`;

export const Text = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  /* or 139% */

  text-align: center;

  color: ${({ theme }) => theme.colors.charcoal};
`;

export const BodyOne = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
  font-weight: ${({ bold, fontWeight, medium, theme }) =>
    fontWeight ? fontWeight : bold ? (theme.old ? 'bold' : 600) : medium ? '500' : 'normal'};
  font-size: 24px;
  line-height: 33px;
  /* identical to box height, or 137% */

  text-align: ${({ align }) => (align ? align : 'initial')};
  letter-spacing: 0.02em;

  @media (max-width: 992px) {
    font-size: 18px;
    line-height: 25px;
  }
`;

export const BodyTwo = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, theme }) => (bold ? (theme.old ? 'bold' : 600) : 'normal')};
  font-size: 18px;
  line-height: 25px;
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
`;

export const BodyTwoSecondary = styled(BodyTwo)`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  font-weight: 300;
  font-size: 22px;
`;

export const BodyThree = styled.div`
  color: ${({ color , theme }) => (color ? color : theme.colors.charcoal)};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, fontWeight, medium, theme }) =>
    fontWeight ? fontWeight : bold ? (theme.old ? 'bold' : 600) : medium ? '500' : 'normal'};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'initial')};
  font-size: 16px;
  line-height: 23px;

  /* identical to box height, or 144% */
`;

export const BodyFour = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, fontWeight, medium, theme }) =>
    fontWeight ? fontWeight : bold ? (theme.old ? 'bold' : 600) : medium ? '500' : 'normal'};
  font-size: 14px;
  line-height: 17px;
  /* identical to box height, or 144% */
  text-transform: ${({ upperCase }) => (upperCase ? 'uppercase' : 'none')};

  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
`;

export const BodyFive = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, fontWeight, medium, theme }) =>
    fontWeight ? fontWeight : bold ? (theme.old ? 'bold' : 600) : medium ? '500' : 'normal'};
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.0007em;
  text-transform: ${({ upperCase }) => (upperCase ? 'uppercase' : 'none')};
  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
`;

export const SubtitleThree = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, theme }) => (bold ? (theme.old ? 'bold' : 600) : '500')};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
`;

export const SubtitleTwo = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, theme }) => (bold ? (theme.old ? 'bold' : 600) : '500')};
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};
`;

export const SubtitleOne = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, theme }) => (bold ? (theme.old ? 'bold' : 600) : '500')};
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ color, theme }) => (color ? color : theme.colors.charcoal)};

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
